import React from 'react';
import './LinkBlock.css';
import { Link } from 'react-router-dom';


const LinkBlock = (props) => {
  return (
    <div className="home-wrapper">
			{props.items.map( (item) =>
				<Link key={item.url} to={ item.url } className="linc-home-item"> 
					<div className="home-item">{ item.text }</div> 
				</Link>
			) }
		</div>
  );
}

export default LinkBlock;


// WEBPACK FOOTER //
// ./src/Components/LinkBlock.jsx